import SearchControlsWrapper from './SearchControlsWrapper';

export default SearchControlsWrapper;
